module.exports = "/img/5.750ce5.webp";